import api, { ApiResponse } from './api';

import { Chat, GetChatProps, UpdateChatProps } from 'entities/Chat';

interface UpdateChatResponse {
  success: boolean;
  data: Chat;
}

export const updateChatService = (
  data: UpdateChatProps
): ApiResponse<UpdateChatResponse> => {
  return api({
    method: 'patch',
    url: `chats/${data.token}`,
    data: {
      password: data.password,
    },
  });
};

interface GetChatResponse {
  success: boolean;
  data: Chat;
}

export const getChatService = (
  data: GetChatProps
): ApiResponse<GetChatResponse> =>
  api({
    method: 'get',
    url: `chats/${data.token}`,
  });
